import React from 'react';
import {
  ColumnContainer,
  Heading,
  LoginBackImage,
  LoginContainer,
  LoginWrapper,
  Logo,
  LogoWrap,
  PartialWrapLoginBackImage,
  Wrap,
} from 'pages/login/login_style';
import { useSelector } from 'react-redux';
import LoginComponent from 'component/login_components/login';

const LoginForm = () => {
  const { defaultTheme } = useSelector((state) => state.themes);
  return (
    <div className='body-content'>
      {defaultTheme === 'globlue' ? (
        <LoginBackImage className='login-background-image'>
          <ColumnContainer className='globlue login-column-container'>
            <div className='column' />
            <div className='column'>
              <Wrap className='login-wrapper'>
                <LoginContainer className='login-container'>
                  <LogoWrap className='login-logo-wrap'>
                    <Logo alt='Logo' className='login-logo' />
                  </LogoWrap>
                  <LoginComponent theme={defaultTheme} />
                </LoginContainer>
              </Wrap>
            </div>
          </ColumnContainer>
        </LoginBackImage>
      ) : defaultTheme === 'mornglow' ? (
        <PartialWrapLoginBackImage className='mornglow login-partial-wrapper'>
          <ColumnContainer className='mornglow login-column-container'>
            <div className='column'>
              <Wrap className='logoleft login-wrapper'>
                <Logo className='leftsideLogo login-logo' alt='Logo' />
                <LoginWrapper className={`${defaultTheme} login-inside-wrap`}>
                  <LoginContainer className='login-container'>
                    <Heading className={`${defaultTheme} login-heading`}>Login</Heading>
                    <LoginComponent theme={defaultTheme} />
                  </LoginContainer>
                </LoginWrapper>
              </Wrap>
            </div>
          </ColumnContainer>
          <LoginBackImage className='login-background-image'></LoginBackImage>
        </PartialWrapLoginBackImage>
      ) : defaultTheme === 'nitrate' ? (
        <LoginBackImage className='login-background-image'>
          <ColumnContainer className='nitrate login-column-container'>
            <Wrap className='login-wrapper'>
              <LoginWrapper className={`${defaultTheme} login-inside-wrap`}>
                <LoginContainer className='login-container'>
                  <LogoWrap className='login-logo-wrap'>
                    <Logo alt='Logo' className='login-logo' />
                  </LogoWrap>
                  <LoginComponent theme={defaultTheme} />
                </LoginContainer>
              </LoginWrapper>
            </Wrap>
          </ColumnContainer>
        </LoginBackImage>
      ) : defaultTheme === 'teamring' ? (
        <PartialWrapLoginBackImage className='login-partial-wrapper'>
          <LoginBackImage className='login-background-image'>
            <Wrap className='logoleft login-wrapper'>
              <Logo className='leftsideLogo login-logo' alt='Logo' />
            </Wrap>
          </LoginBackImage>
          <ColumnContainer className='teamring login-column-container'>
            <Wrap className='login-wrapper-second'>
              <LoginWrapper className={`${defaultTheme} login-inside-wrap`}>
                <LoginContainer className='login-container'>
                  <Heading className={`${defaultTheme} login-heading`}>Login</Heading>
                  <LoginComponent theme={defaultTheme} />
                </LoginContainer>
              </LoginWrapper>
            </Wrap>
          </ColumnContainer>
        </PartialWrapLoginBackImage>
      ) : (
        ''
      )}
    </div>
  );
};

export default LoginForm;
